import React, { Component, Children, cloneElement } from 'react';
import { getCurrentWindowWidth, getUrlSearchIds } from '../../../Utils';
import { withRouter } from 'react-router-dom';
//styles
import { CaruselContainer, SliderRow } from './style';
import Slider from 'react-slick';

function _css(translate = 0, currentSlide = 0, transition) {
    return {
        transform: `translateX(${translate}px)`,
        transition: `transform ease-out ${currentSlide !== 0 ? transition : 0}s`,
    };
}

function updatedChildren(options) {
    return function(child) {
        return cloneElement(child, options);
    };
}

class Carusel extends Component {
    static SliderRow = ({ children, ...props }) => <SliderRow {...props}>{children}</SliderRow>;
    constructor() {
        super();

        this.state = { ...this._getInitilState() };
    }

    static defaultProps = {
        duration: 3000,
        transition: 0.45,
    };

    _getInitilState = () => ({
        translateXValue: 0,
        currentSliderIndex: 0,
        slideLength: 0,
        windowWidth: 0,
        currentPosition: 1,
    });

    static getDerivedStateFromProps({ location }, prevState) {
        if (location.search.length > 0) {
            let ids = getUrlSearchIds(location.search);
            if (ids.split(',').length > 0) {
                const _updatedState = Object.assign({}, prevState);
                _updatedState['slideLength'] = ids.split(',').length;

                if (prevState.windowWidth === 0) {
                    _updatedState['windowWidth'] = getCurrentWindowWidth();
                }

                return _updatedState;
            }
            return null;
        }
        return null;
    }

    intervalId = null;

    restartSlider = () => {
        this.setState({ ...this._getInitilState() });
    };

    reanimateSlider = () => {
        this.intervalId = setInterval(() => {
            this.setState(this.updateSlider);
        }, this.props.duration);
    };

    updateSlider = prevState => {
        if (document.hasFocus()) {
            const _prevState = Object.assign({}, prevState);

            if (prevState.slideLength === prevState.currentSliderIndex + 1) {
                _prevState['translateXValue'] = 0;
                _prevState['currentSliderIndex'] = 0;
            } else {
                _prevState['translateXValue'] = prevState.translateXValue - this.getSlideWidth();
                _prevState['currentSliderIndex'] = prevState.currentSliderIndex + 1;
            }

            return _prevState;
        } else {
            return null;
        }
    };

    killSlider = () => {
        clearInterval(this.intervalId);
    };

    setSliderStyles = () => {
        const { currentSliderIndex, translateXValue } = this.state;
        const { transition } = this.props;

        return _css(translateXValue, currentSliderIndex, transition);
    };

    getSlideWidth = () => {
        if (document.querySelector('.slider-wrapper__slide')) {
            return document.querySelector('.slider-wrapper__slide').clientWidth;
        }
    };

    handleMouseOver = event => {
        this.killSlider();
    };

    handleMouseLeave = event => {
        this.reanimateSlider();
    };

    propsCollectionForChildren = () => ({
        className: 'slider-wrapper__slide',
        onMouseOver: this.handleMouseOver,
        onMouseLeave: this.handleMouseLeave,
    });

    renderChildrenWithProps = () => {
        const providedProps = this.propsCollectionForChildren();

        return Children.map(this.props.children, updatedChildren(providedProps), null);
    };

    handleBeforeChange = (oldIndex, newIndex) => {
        this.setState({ currentPosition: newIndex + 1 });
    };

    handleOnInit = ar => {};

    settings = () => {
        const settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            autoplay: false,
            accessibility: false,
            arrows: false,
            autoplaySpeed: 8000,
            beforeChange: this.handleBeforeChange,
            onInit: this.handleOnInit,
            pauseOnHover: false,
            beforeChange: (oldIndex, newIndex) => this.props.getCurrentSlide(newIndex),
        };

        let ids = getUrlSearchIds(this.props.location.search);

        if (ids) {
            if (Array.from(ids.replace(/,/g, '')).length > 1) {
                settings['autoplay'] = true;
            }
        }

        return settings;
    };

    render() {
        return (
            <CaruselContainer>
                <Slider {...this.settings()}>{this.props.children}</Slider>
            </CaruselContainer>
        );
    }

    getSnapshotBeforeUpdate(prevProps, prevState) {
        if (this.state.windowWidth !== 0 && this.state.windowWidth !== getCurrentWindowWidth()) {
            return { restartSlider: true };
        }

        return null;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (snapshot !== null && snapshot.restartSlider) {
            // this.restartSlider();
        }
    }

    componentWillUnmount() {
        // this.killSlider();
        // this.props.killSlider()
    }
}

Carusel = withRouter(Carusel);

export { Carusel };



// WEBPACK FOOTER //
// ./src/UI/Containers/Caresel/Carusel.js